import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import { Drawer } from "vaul"

import { GetStartedModalMenu } from "./Menu"
import { TransferInstructions } from "./TransferInstructions"

import CloseIcon from "@components/elements/V2/Icons/CloseIcon"
import { Color } from "@constants/V2/color"
import { usePageLayoutState } from "@utils/layout"
import React, { useState } from "react"

type Props = {
  data: Storyblok.GetStartedData
  alwaysShow?: boolean
}

export const GetStartedModal = ({ data, alwaysShow = false }: Props) => {
  const { isGetStartedModalOpen, setIsGetStartedModalOpen: setIsOpen } =
    usePageLayoutState()
  const isOpen = alwaysShow || isGetStartedModalOpen
  const [showTransfer, setShowTransfer] = useState(false)

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open)
    if (!open) {
      setShowTransfer(false)
    }
  }

  return (
    <Drawer.Root
      open={isOpen}
      direction="bottom"
      onOpenChange={handleOpenChange}
    >
      <Drawer.Portal>
        <Drawer.Overlay className="fixed -top-28 bottom-0 left-0 right-0 z-50 bg-black/30" />

        <VisuallyHidden>
          <Drawer.Description>Get started</Drawer.Description>
        </VisuallyHidden>

        <Drawer.Content className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="relative z-20 max-h-[90vh] w-[90vw] overflow-y-auto rounded-10 bg-white sm:max-w-[460px]">
            {showTransfer ? (
              <button
                type="button"
                className="absolute right-20 top-[19px]"
                onClick={() => setShowTransfer(false)}
              >
                <CloseIcon
                  width="30px"
                  height="30px"
                  hideBorder
                  strokeWidth="2"
                  strokeColor={Color.Black}
                />
              </button>
            ) : (
              <Drawer.Trigger className="absolute right-20 top-[19px]">
                <CloseIcon
                  width="30px"
                  height="30px"
                  hideBorder
                  strokeWidth="2"
                  strokeColor={Color.Black}
                />
              </Drawer.Trigger>
            )}

            {showTransfer ? (
              <TransferInstructions />
            ) : (
              <GetStartedModalMenu
                heading={data.heading}
                subheading={data.subheading}
                items={data.items}
                onClose={() => setIsOpen(false)}
              />
            )}
          </div>

          <Drawer.Close className="fixed inset-0" />
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
